module.exports = __webpack_public_path__ + "static/img/icon_logo.b3c70f2d.png";